var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    size: "256"
                  }
                },
                [_vm._v(" mdi-alert ")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c("gg-card-title", [
                _vm._v(" Multiple Affiliate Accounts Found ")
              ])
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "subtitle-1 text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _vm._v(
                " We have found multiple affiliate accounts with the email address " +
                  _vm._s(_vm.SessionProfile.email) +
                  " and we cannot automatically link your account. You will need to speak to our affiliate support team or your dedicated account manager to resolve this conflict. "
              )
            ]
          ),
          _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    to: {
                      name: "support_ticketnew"
                    }
                  }
                },
                [_vm._v(" Contact Support ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }